import type { UseUmaPermissionsQueryParams } from '@bos/openid-connect';
import {
	useUmaPermissionsQuery,
	getScopesFromUmaPermissions,
} from '@bos/openid-connect';

export const useUserScopesFromUmaPermissions = (
	params: UseUmaPermissionsQueryParams,
) => {
	const {
		data: permissions,
		isLoading,
		isError,
	} = useUmaPermissionsQuery(params);

	const userScopes = permissions
		? getScopesFromUmaPermissions(permissions)
		: undefined;

	return { userScopes, isLoading, isError };
};
